/**
 * session_id cookie'sinin adı ve okuma yardımcısı.
 *
 * Ayrı dosyada duruyor çünkü hem client (`sessionStorage.ts`, js-cookie ile yazar)
 * hem de sunucu (`api/server.ts`, `cookies()` ile okur) kullanıyor. Bu dosya
 * kasıtlı olarak hiçbir tarayıcı kütüphanesi import etmez — aksi hâlde js-cookie
 * `server-only` işaretli sunucu modülüne sızardı.
 */
export const SESSION_ID_COOKIE = "session_id";

/** localStorage döneminden kalan sarmalayıcı biçim: `{ value, timestamp }`. */
export interface SessionRecord {
  value: string;
  timestamp: number;
}

export const parseSessionRecord = (
  raw: string | undefined,
): SessionRecord | null => {
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as SessionRecord;
    if (typeof parsed?.value !== "string") return null;
    if (typeof parsed?.timestamp !== "number") return null;
    return parsed;
  } catch {
    return null;
  }
};

export const parseSessionIdCookie = (raw: string | undefined): string | null =>
  parseSessionRecord(raw)?.value ?? null;
